import { Spinner } from 'components/spinner/Spinner';
import React from 'react';

const LoadingFallback: React.FC = () => {
  return (
    <div
      style={{
        minHeight: 'calc(100vh - 120px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
      }}
    >
      <Spinner />
    </div>
  );
};

export default LoadingFallback;
